import {AreasOfWork} from '../modules/blocks';

export const AreasOfWorkPage = ()=> {
    return <AreasOfWork />
}
